import React from 'react'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

export default function SectionTitle({ text }) {
  const { isCollapsed } = useSidebarCollapse()

  if (isCollapsed) return null

  return (
    <div className="px-4">
      <p className="text-xs text-gray-300 dark:text-gray-400 uppercase">{text}</p>
    </div>
  )
}